<template>
    <minimal>
        <div class="text-center">
            <h1>{{useError().value.statusMessage}}</h1>
<!--            <p>{{useError().value.data}}</p>-->
        </div>
    </minimal>
</template>

<script setup>
const Minimal = defineAsyncComponent(() => import('~/errors/minimal.vue'))

useHead({
    title: '403'
})
</script>
